// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { mobileView } from '../../_common/api/utility';

const Wrapper = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    flex-direction: column;
    width: ${({ mobile }) => mobile ? '90vw' : '60vw'};
    margin: 0 auto;
    height: 100%;
    transition: height 0.2s;

    animation: fadeIn 0.25s;
    animation-fill-mode: forwards;
`

const Page = ({ children, ...props }) => {
    return (
        <Wrapper mobile={mobileView}>
            {children}
        </Wrapper>
    );
}

export default Page;